{
  "id": "campaign-147",
  "name": "Honey Pasture",
  "seed": "campaign:147",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......#.............",
    "....................",
    ".............***....",
    "..............*h....",
    "....................",
    "....................",
    "w...............T...",
    "wwwww+w.............",
    "...ww.www+w.........",
    "..........wwwwww+www",
    "....................",
    ".............x......",
    "...h........,.......",
    "....,...Y...,,......",
    ",,,.........,.......",
    ".,..................",
    ".T..................",
    "...........x........",
    "S............T......"
  ],
  "critters": [
    {
      "kind": "stag",
      "x": 4,
      "y": 3
    },
    {
      "kind": "fox",
      "x": 16,
      "y": 1
    },
    {
      "kind": "deer",
      "x": 1,
      "y": 1
    },
    {
      "kind": "deer",
      "x": 1,
      "y": 0
    },
    {
      "kind": "deer",
      "x": 9,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 19,
      "y": 18
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 2
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 8,
      "y": 3,
      "w": 5,
      "h": 5
    },
    {
      "x": 0,
      "y": 1,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 147,
  "biome": "meadow",
  "par": {
    "reel": 12701,
    "push": 11621,
    "selfPropelled": 9828,
    "tractor": 8620,
    "zeroTurn": 7483,
    "fairway": 4610
  },
  "goldTime": {
    "reel": 12701,
    "push": 11517,
    "selfPropelled": 9828,
    "tractor": 8620,
    "zeroTurn": 7480,
    "fairway": 4121
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 3,
      "zeroTurn": 0,
      "fairway": 17
    },
    "gold": {
      "reel": 0,
      "push": 25,
      "selfPropelled": 0,
      "tractor": 3,
      "zeroTurn": 42,
      "fairway": 38
    }
  }
}
